import featureToggles from 'shared/featureToggles'

const filters = [
    {
        name: 'map.filter.facilities',
        options: [
            {
                label: 'map.filter.247',
                value: 'isOpen247',
            },
            {
                label: 'map.filter.surface',
                value: 'isOnSurface',
            },
            {
                label: 'map.filter.valet',
                value: 'services.valetParking',
            },
            {
                label: 'map.filter.accessibility',
                value: 'services.accessibilityForDisabled',
            },
            {
                label: 'map.filter.ground',
                value: 'mscpGarageIsAboveGround',
            },
            {
                label: 'map.filter.wc',
                value: 'services.toilets',
            },
            {
                label: 'map.filter.underground',
                value: 'garageIsUnderground',
            },
            {
                label: 'map.filter.e.charging',
                value: 'services.electricCharging',
            },
            {
                label: 'map.filter.e.plugin',
                value: 'services.electricPlugin',
            },
            {
                label: 'map.filter.parent.child',
                value: 'services.parentAndChild',
            },
            {
                label: 'map.filter.women',
                value: 'womenOnly',
            },
        ],
    },
    {
        name: 'map.filter.services',
        options: [
            {
                label: 'map.filter.car.wash',
                value: 'services.carWash',
            },
            {
                label: 'map.filter.umbrellas',
                value: 'services.umbrella',
            },
            {
                label: 'map.filter.car.rental',
                value: 'services.carRental',
            },
            {
                label: 'map.filter.bicycle.rental',
                value: 'services.bicycleRental',
            },
            {
                label: 'map.filter.car.service',
                value: 'services.carService',
            },
            {
                label: 'map.filter.tyre.inflation',
                value: 'services.tyreInflation',
            },
        ],
    },
]

if (featureToggles.canFilterByVehicleTypes) {
    filters.unshift({
        name: 'map.filter.vehicle.type',
        options: [
            {
                label: 'map.filter.height.over.3m',
                value: 'heightIsOver3m5',
            },
            {
                label: 'map.filter.motocycle',
                value: 'motorcyclesAllowed',
            },
        ],
    })
}

export default filters
